const SERVER_IP = "localhost";
const SERVER_PORT = "8000";


const TRANSPORTER_NAME = process.env.REACT_APP_CLIENT_NAME;


const USE_OVERLAY = true;

const getLocalFlag = () => {
  try {
    let lo = localStorage.getItem("local_flag") === "true";
    console.log("Inansdsnns", lo);
    return lo;
  } catch (e) {
    return false;
  }
};
var SERVER_URL = "";
if (getLocalFlag()) {
  console.log("in if");
  // SERVER_URL = "http://localhost:8000";
  // SERVER_URL = "http://103.180.39.155:8001";
  SERVER_URL = process.env.REACT_APP_LOCAL_URL;
  // SERVER_URL = SERVER_URL_CMP
} else {
  console.log("in else");
 //  SERVER_URL = "http://localhost:8000";
  // SERVER_URL = "http://103.180.39.155:8001";
   SERVER_URL = process.env.REACT_APP_GLOBAL_URL;
  // SERVER_URL = SERVER_URL_CMP
  // SERVER_URL = `http://${SERVER_IP}:${SERVER_PORT}`;
  // const SERVER_URL = "https://d7edf369be0e55.localhost.run";
}
// SERVER_URL = "http://" + SERVER_IP + ":" + SERVER_PORT;

var UTILITY_SERVER_URL =  "https://printbe.techiteasy.co.in";
var UTILITY_SERVER_URL_2 =  "https://printbe.techiteasy.co.in";
var PRINT_SERVER_URL =  "https://printbe.techiteasy.co.in";


export { SERVER_URL, USE_OVERLAY, TRANSPORTER_NAME, UTILITY_SERVER_URL, PRINT_SERVER_URL, UTILITY_SERVER_URL_2 };
